import React, { useEffect, useState } from "react";
import "./AllQuizQuestionsTable.css";
import { MdEdit } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import CreatePersonalityQuestionForm from "./CreateQuestionForm/CreatePersonalityQuestionForm.js";
import PersonalityQuestionDetailForm from "./QuestionDetailForm/PersonalityQuestionDetailForm";

function AllPersonalityQuizQuestionsTable() {
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [questionToDelete, setQuestionToDelete] = useState(null);
  const [createNewQuestion, setCreateNewQuestion] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/personalityQuizQuestions`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          console.error(data.error);
        } else {
          setQuestions(data.quiz_questions);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const deleteQuestion = (quizType, questionId) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/personalityQuizQuestions/delete/${questionId}`,
      {
        method: "DELETE",
        credentials: "include",
      }
    ).then(() => {
      setQuestions((prev) => prev.filter((q) => q._id !== questionId));
    });
  };

    const updateQuestion = (quizType, questionId, updatedData) => {
        fetch(
        `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/personalityQuizQuestions/edit/${questionId}`,
        {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(updatedData),
        }
        ).then(() => {
        setQuestions((prev) =>
            prev.map((q) => (q._id === questionId ? { ...q, ...updatedData } : q))
        );
        setSuccessMessage("Question updated successfully!");
        setTimeout(() => setSuccessMessage(""), 3000);
        });
    };

    const createQuestion = (newData) => {
        fetch(
        `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/personalityQuizQuestions/add`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(newData),
        }
        )
        .then((res) => res.json())
        .then((data) => {
            if (!data.error) {
            setQuestions((prev) => [
                ...prev,
                { ...newData, _id: Date.now().toString() },
            ]);
            setSuccessMessage("Question created successfully!");
            setTimeout(() => setSuccessMessage(""), 3000); // hide after 3s
            }
        });
    };

    return (
        <div className="quiz-questions-table">
        <div className="table-header">
            {/* Success Message */}
            {successMessage && (
                <div className="success-message">{successMessage}</div>
            )}
            <div style={{ width: "120px" }}></div>
            <h3>Personality Quiz Questions</h3>
            <button
            className="blue-button right-button"
            onClick={() => setCreateNewQuestion(true)}
            >
            Create Question
            </button>
        </div>

        <div className="table-wrapper">
            <table>
            <thead>
                <tr>
                <th className="small-col">No.</th>
                <th>Question</th>
                <th>Trait</th>
                <th className="small-col">Score</th>
                <th>Roles</th>
                <th className="small-col">Enabled</th>
                <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {questions.map((q, index) => (
                <tr key={q._id}>
                     <td className="small-col">{index + 1}</td>
                    <td
                    onClick={() => setSelectedQuestion(q)}
                    title={q.questionText}
                    >
                    {q.questionText}
                    </td>
                    <td>{q.questionClass}</td>
                    <td className="small-col">{q.score}</td>
                    <td
                    className="overflow-cell"
                    title={q.visibleToRoles?.join(", ")}
                    >
                    {q.visibleToRoles?.join(", ")}
                    </td>
                    <td className="small-col">{q.enabled ? "Yes" : "No"}</td> 
                    <td>
                    <button onClick={() => setSelectedQuestion(q)}>
                        <MdEdit />
                    </button>
                    <button
                        className="red-button"
                        onClick={() => setQuestionToDelete(q)}
                    >
                        <FaTrashAlt />
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
        {/* Edit Modal */}
        {selectedQuestion && (
            <PersonalityQuestionDetailForm
            question={selectedQuestion}
            onClose={() => setSelectedQuestion(null)}
            onSave={(updatedData) => {
                updateQuestion(
                selectedQuestion.quizType,
                selectedQuestion._id,
                updatedData
                );
                setSelectedQuestion(null);
            }}
            />
        )}

        {/* Delete Modal */}
        {questionToDelete && (
            <div className="modal">
            <div className="modal-content">
                <button
                className="modal-close"
                onClick={() => setQuestionToDelete(null)}
                >
                ×
                </button>
                <h3>Confirm Deletion</h3>
                <p>Are you sure you want to delete this question?</p>
                <div className="modal-buttons">
                <button
                    className="red-button"
                    onClick={() => {
                    deleteQuestion(
                        questionToDelete.quizType,
                        questionToDelete._id
                    );
                    setQuestionToDelete(null);
                    }}
                >
                    Delete
                </button>
                <button onClick={() => setQuestionToDelete(null)}>Cancel</button>
                </div>
            </div>
            </div>
        )}
        {createNewQuestion && (
            <CreatePersonalityQuestionForm
            onClose={() => setCreateNewQuestion(false)}
            onSave={(newData) => {
                createQuestion(newData);
                setCreateNewQuestion(false);
            }}
            />
        )}
        </div>
    );
}

export default AllPersonalityQuizQuestionsTable;